import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Download, Smartphone, Zap, WifiOff, Shield } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Install() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary/5 via-background to-accent/5">
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-gradient-to-br from-primary to-accent mb-6">
              <Download className="w-10 h-10 text-white" />
            </div>
            <h1 className="text-4xl font-bold text-foreground mb-4">
              MediQR als App installieren
            </h1>
            <p className="text-lg text-muted-foreground">
              Genießen Sie alle Vorteile einer nativen App ohne App-Store
            </p>
          </div>

          {/* Benefits */}
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4 mb-12">
            <Card className="p-6 text-center backdrop-blur-md bg-background/60 border-primary/20">
              <Zap className="w-8 h-8 text-primary mx-auto mb-3" />
              <h3 className="font-semibold mb-2">Schneller Start</h3>
              <p className="text-sm text-muted-foreground">
                Sofortiger Zugriff vom Startbildschirm
              </p>
            </Card>
            
            <Card className="p-6 text-center backdrop-blur-md bg-background/60 border-primary/20">
              <WifiOff className="w-8 h-8 text-primary mx-auto mb-3" />
              <h3 className="font-semibold mb-2">Offline verfügbar</h3>
              <p className="text-sm text-muted-foreground">
                Profile auch ohne Internet anzeigen
              </p>
            </Card>
            
            <Card className="p-6 text-center backdrop-blur-md bg-background/60 border-primary/20">
              <Smartphone className="w-8 h-8 text-primary mx-auto mb-3" />
              <h3 className="font-semibold mb-2">Native App-Feeling</h3>
              <p className="text-sm text-muted-foreground">
                Vollbildmodus ohne Browser-Leiste
              </p>
            </Card>
            
            <Card className="p-6 text-center backdrop-blur-md bg-background/60 border-primary/20">
              <Shield className="w-8 h-8 text-primary mx-auto mb-3" />
              <h3 className="font-semibold mb-2">Immer aktuell</h3>
              <p className="text-sm text-muted-foreground">
                Automatische Updates im Hintergrund
              </p>
            </Card>
          </div>

          {/* Installation Instructions */}
          <div className="space-y-6 mb-12">
            <Card className="p-6 backdrop-blur-md bg-background/60 border-primary/20">
              <h2 className="text-2xl font-bold text-foreground mb-4 flex items-center gap-2">
                <Smartphone className="w-6 h-6" />
                Installation auf Android
              </h2>
              <ol className="space-y-3 text-muted-foreground">
                <li className="flex gap-3">
                  <span className="font-bold text-primary">1.</span>
                  <span>Tippen Sie auf das <strong>Menü-Symbol</strong> (drei Punkte) in Chrome</span>
                </li>
                <li className="flex gap-3">
                  <span className="font-bold text-primary">2.</span>
                  <span>Wählen Sie <strong>"App installieren"</strong> oder <strong>"Zum Startbildschirm hinzufügen"</strong></span>
                </li>
                <li className="flex gap-3">
                  <span className="font-bold text-primary">3.</span>
                  <span>Bestätigen Sie die Installation</span>
                </li>
                <li className="flex gap-3">
                  <span className="font-bold text-primary">4.</span>
                  <span>MediQR erscheint nun auf Ihrem Startbildschirm</span>
                </li>
              </ol>
            </Card>

            <Card className="p-6 backdrop-blur-md bg-background/60 border-primary/20">
              <h2 className="text-2xl font-bold text-foreground mb-4 flex items-center gap-2">
                <Smartphone className="w-6 h-6" />
                Installation auf iOS (iPhone/iPad)
              </h2>
              <ol className="space-y-3 text-muted-foreground">
                <li className="flex gap-3">
                  <span className="font-bold text-primary">1.</span>
                  <span>Öffnen Sie MediQR in <strong>Safari</strong></span>
                </li>
                <li className="flex gap-3">
                  <span className="font-bold text-primary">2.</span>
                  <span>Tippen Sie auf das <strong>Teilen-Symbol</strong> (Quadrat mit Pfeil nach oben)</span>
                </li>
                <li className="flex gap-3">
                  <span className="font-bold text-primary">3.</span>
                  <span>Scrollen Sie nach unten und wählen Sie <strong>"Zum Home-Bildschirm"</strong></span>
                </li>
                <li className="flex gap-3">
                  <span className="font-bold text-primary">4.</span>
                  <span>Tippen Sie auf <strong>"Hinzufügen"</strong></span>
                </li>
              </ol>
            </Card>
          </div>

          {/* CTA */}
          <div className="text-center">
            <Link to="/">
              <Button size="lg" className="gap-2">
                Zurück zur Startseite
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
